export default {"src":"/_next/static/media/clip.d1a3f8d8.svg","height":25,"width":24};